import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { LANDING_PAGE_BASE_URL } from '../../config';
import { useTermsAndConditions } from '../../hooks/useTermsAndConditions';

const StyledButtonLink = styled.a`
    width: 100%;
`;

export const TermsLinkWrapper = ({ children }) => {
    const { documentUrl } = useTermsAndConditions();

    if (documentUrl) {
        return (
            <a href={documentUrl} target="_blank" rel="noreferrer">
                {children}
            </a>
        );
    }
    return <>{children}</>;
};

export const Itv7TermsLinkWrapper = ({ children }) => {
    return (
        <StyledButtonLink
            href={`${LANDING_PAGE_BASE_URL}/terms`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {children}
        </StyledButtonLink>
    );
};

export const RacingButtonLinkWrapper = ({ children }) => {
    return (
        <StyledButtonLink href={`${LANDING_PAGE_BASE_URL}/home`}>
            {children}
        </StyledButtonLink>
    );
};

export const FootballButtonLinkWrapper = ({ children }) => {
    return (
        <StyledButtonLink href={`${LANDING_PAGE_BASE_URL}/football`}>
            {children}
        </StyledButtonLink>
    );
};

TermsLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

Itv7TermsLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

RacingButtonLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};

FootballButtonLinkWrapper.propTypes = {
    children: PropTypes.node.isRequired
};
